var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4117 17.948C22.1438 18.389 22.2265 19.0466 22.5849 19.4044L29.3409 26.161C30.2198 27.0399 30.2198 28.4645 29.3409 29.3429C28.4625 30.2218 27.038 30.2218 26.159 29.3429L19.4024 22.5869C19.0394 22.2233 18.3844 22.1511 17.9371 22.4184C17.9371 22.4184 17.7718 22.5413 17.2518 22.7951C15.6655 23.5683 13.8837 24.002 12.0003 24.002C5.37296 24.002 0 18.6297 0 12.0022C0 5.37491 5.37282 0.00195312 12.0003 0.00195312C18.6276 0.00195312 24 5.37478 24 12.0022C24 13.8918 23.5632 15.6801 22.7848 17.2705C22.5331 17.7842 22.4117 17.948 22.4117 17.948H22.4117ZM12.0003 19.5022C16.1422 19.5022 19.5003 16.1441 19.5003 12.0022C19.5003 7.85977 16.1422 4.50218 12.0003 4.50218C7.8579 4.50218 4.5003 7.85977 4.5003 12.0022C4.5003 16.1441 7.8579 19.5022 12.0003 19.5022Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMenuIcon);
export default __webpack_public_path__ + "static/media/search-menu-icon.57bfa2a41230b8be98ae5b3686b1c036.svg";
export { ForwardRef as ReactComponent };